// extracted by mini-css-extract-plugin
export default {"popover":"uOIZYARDS8do9FUvWqMb"};